import React from 'react';

import Box from '@mui/material/Box';

// @ts-expect-error FIXME TS7006
const RouterBackground = (props) => (
  <Box
    id='router-default-background'
    display='flex'
    justifyContent='center'
    alignItems='center'
    height='100vh'
    width='100vw'
    bgcolor='background.paper'
    position='absolute'
    zIndex={-1}
    {...props}
  />
);

export default RouterBackground;
